import { Dialog, DialogActions, DialogContentText, DialogTitle } from '@mui/material';
import Checkbox from '../../../components/checkbox/Checkbox';
import styled from 'styled-components';
import { StyledDialogContent } from './CreateGroup';
import Button from '../../../components/button/Button';
import ItemService from '../../../services/ItemService';
import NotificationService from '../../../services/NotificationService';
import { log } from '../../../utils/logging/log';
import { useState } from 'react';
import { FavoriteItemGroupDTO } from '../../../api/api';

interface Props {
  handleClose: () => void;
  groups: FavoriteItemGroupDTO[];
  itemId: string;
  setGroupsCallback: (groups: FavoriteItemGroupDTO[]) => void;
}

export default function Groups(props: Props) {
  const { handleClose, groups: _groups, itemId, setGroupsCallback } = props;

  const [tempGroups, setTempGroups] = useState<FavoriteItemGroupDTO[]>(_groups);

  const onChangeHandler = (itemId: number, group: FavoriteItemGroupDTO) => {
    if (!group.groupId) return;
    if (group.itemIds?.includes(itemId.toString())) {
      removeFromGroupCallback(itemId, group.groupId);
    } else {
      addToGroupCallback(itemId, group.groupId);
    }
  };

  const addToGroupCallback = (itemId: number, groupId: number) => {
    setTempGroups((prev) =>
      prev.map((group) => {
        if (group.groupId === groupId) {
          return { ...group, itemIds: [...(group.itemIds ?? []), itemId.toString()] };
        } else {
          return group;
        }
      })
    );
  };

  const removeFromGroupCallback = (itemId: number, groupId: number) => {
    setTempGroups((prev) =>
      prev.map((group) => {
        if (group.groupId === groupId) {
          return { ...group, itemIds: group.itemIds?.filter((goodId) => goodId !== itemId.toString()) };
        } else {
          return group;
        }
      })
    );
  };

  const submit = (event: any) => {
    event.preventDefault();
    const payload = {
      itemId: itemId.toString(),
      groupIds: tempGroups.filter((obj) => obj.itemIds?.includes(itemId)).map((group) => group.groupId) as number[]
    };
    ItemService.updateFavoriteItems(payload)
      .then(() => {
        setGroupsCallback(tempGroups);
        handleClose();
      })
      .catch((e) => {
        log(e);
        NotificationService.error('Favoritlisterne kunne ikke opdateres');
      });
  };

  return (
    <Dialog open onClose={handleClose} PaperProps={{ component: 'form' }}>
      <DialogTitle>Vælg grupper</DialogTitle>
      <StyledDialogContent>
        <StyledDialogContentText>Tilføj eller fjern varen fra de ønskede grupper</StyledDialogContentText>
        {tempGroups.map((group) => (
          <Checkbox
            key={group.groupId}
            onChange={() => onChangeHandler(parseInt(itemId), group)}
            label={group.name}
            checked={group.itemIds?.includes(itemId)}
          />
        ))}
      </StyledDialogContent>
      <DialogActions>
        <Button variant="secondary" onClick={handleClose}>
          Fortryd
        </Button>
        <Button onClick={submit}>Gem</Button>
      </DialogActions>
    </Dialog>
  );
}

const StyledDialogContentText = styled(DialogContentText)`
  padding-bottom: 10px;
`;
